<script setup>

const props = defineProps({
    color: {
        type: String,
    },
    value: {
        default: 'white',
    },
});
</script>

<template>
        <div class="logo lg:px-6 text-[1.2rem] sm:text-[1.5rem] md:text-[1.5rem] lg:text-[1.5rem] flex items-center transition-colors duration-1000">
                <span class="logo-svg mr-1" style="width: 1.2em; height: 1.2em; display: inline-block; vertical-align: middle;">
                        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                width="100%" height="100%" viewBox="0 0 1280.000000 1280.000000"
                                preserveAspectRatio="xMidYMid meet">
                                <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
                                        fill="#346fdb" stroke="none">
                                        <path d="M5995 11719 c-1542 -123 -2936 -887 -3857 -2114 -89 -119 -298 -425
                                        -298 -438 0 -3 21 3 46 14 25 11 52 18 61 15 8 -4 82 16 164 44 323 108 603
                                        167 954 201 140 13 513 18 600 7 33 -4 89 -10 125 -13 36 -3 72 -8 80 -10 8
                                        -2 36 -7 61 -9 304 -35 778 -191 1089 -359 l115 -62 1300 -3 c715 -1 1311 0
                                        1323 3 22 5 23 9 18 53 -4 26 -9 72 -11 102 -3 30 -9 78 -15 105 -5 28 -17 91
                                        -26 140 -150 821 -656 1616 -1374 2160 -96 72 -247 176 -252 174 -2 -1 -48 -5
                                        -103 -10z"/>
                                        <path d="M6530 11717 c8 -8 49 -41 90 -74 425 -343 805 -824 1040 -1315 216
                                        -453 327 -895 355 -1421 l6 -117 656 -1138 c361 -625 658 -1139 660 -1141 1
                                        -2 9 1 16 8 8 6 21 9 30 6 9 -4 57 25 125 77 660 496 1113 1231 1296 2104 43
                                        208 80 534 63 561 -4 6 -4 18 -1 27 7 17 -110 192 -241 361 -416 535 -923 985
                                        -1497 1328 -620 371 -1328 616 -2045 707 -139 18 -406 40 -488 40 -67 0 -77
                                        -2 -65 -13z"/>
                                        <path d="M3030 9215 c-441 -42 -821 -144 -1235 -332 -77 -35 -145 -69 -152
                                        -76 -17 -17 -135 -277 -203 -447 -316 -795 -435 -1688 -339 -2555 51 -465 172
                                        -946 347 -1385 102 -256 271 -599 280 -569 2 8 11 28 18 44 7 17 23 80 34 140
                                        118 619 385 1210 759 1679 247 311 520 560 856 782 77 51 146 102 153 114 8
                                        12 266 459 574 994 309 534 592 1024 630 1089 46 81 70 132 73 160 4 48 20 37
                                        -182 122 -479 203 -1073 291 -1613 240z"/>
                                        <path d="M11060 8899 c-102 -648 -332 -1218 -685 -1704 -290 -398 -625 -706
                                        -1078 -990 -9 -5 -284 -476 -613 -1045 -328 -569 -623 -1081 -656 -1138 -35
                                        -59 -57 -107 -52 -112 15 -15 125 -67 231 -109 145 -58 324 -114 453 -143 25
                                        -5 63 -14 85 -19 64 -14 203 -39 248 -44 23 -3 53 -8 67 -10 24 -5 55 -8 245
                                        -20 509 -34 1039 56 1557 263 129 52 280 123 306 144 22 18 119 227 201 431
                                        198 495 315 1003 361 1561 10 118 12 477 4 666 -3 52 -5 104 -5 115 0 11 -5
                                        58 -11 105 -5 47 -11 112 -14 145 -2 33 -6 67 -9 75 -2 8 -7 40 -10 70 -3 30
                                        -8 62 -10 70 -2 8 -7 35 -10 60 -17 136 -93 460 -164 695 -87 291 -261 706
                                        -393 944 l-36 63 -12 -73z"/>
                                        <path d="M3389 6242 c-220 -158 -498 -421 -663 -627 -398 -500 -660 -1113
                                        -755 -1770 -12 -77 -24 -192 -27 -255 l-6 -115 87 -125 c608 -865 1435 -1521
                                        2412 -1911 167 -67 450 -160 614 -203 190 -49 501 -111 609 -122 25 -2 52 -6
                                        60 -9 8 -3 45 -7 80 -10 36 -3 99 -9 140 -14 41 -5 89 -9 105 -9 64 -2 230 -1
                                        232 1 1 2 -54 49 -123 107 -662 548 -1131 1319 -1292 2125 -25 123 -31 158
                                        -38 226 -3 30 -8 57 -10 60 -5 9 -16 163 -19 269 -1 47 -6 101 -10 120 -5 19
                                        -294 530 -644 1135 -349 605 -644 1117 -655 1137 -12 21 -23 38 -26 38 -3 -1
                                        -35 -22 -71 -48z"/>
                                        <path d="M5032 3718 c104 -1034 676 -1970 1585 -2595 l83 -56 93 1 c220 4 664
                                        74 967 153 775 203 1463 558 2090 1078 154 128 523 496 650 651 204 247 426
                                        560 415 587 -3 8 7 35 21 59 l26 45 -53 -22 c-116 -47 -371 -130 -504 -163
                                        -903 -230 -1804 -134 -2605 275 l-135 69 -1321 0 -1320 0 8 -82z"/>
                                </g>
                        </svg>
                </span>

                <a href="/" :class="color === 'white' ? 'headshots-white' : 'headshots'" class="transition-colors duration-500">Headshot</a>
                <a href="/" class="online">
                        <span class="letter o" data-letter="O">O</span>
                        <span class="letter n" data-letter="n">n</span>
                        <span class="letter l" data-letter="l">l</span>
                        <span class="letter i" data-letter="i">i</span>
                        <span class="letter n2" data-letter="n">n</span>
                        <span class="letter e" data-letter="e">e</span>
                </a>
        </div>
</template>



<style scoped>
/* Basic Styling */


.logo {
        font-weight: 700;
        color: #000000;
}

.headshots {
        color: #161e49;
}

.headshots-white {
        color: #d1d6e1eb;
}

/* outline utilities removed */

.online {
        display: inline-flex;
        position: relative;
}

/* Main Text and Animation for Each Letter */
.letter {
      position: relative;
      color: #050815; /* Start with navy color */
      animation: glow 10s ease-in-out infinite;
    }

    /* Color Transition Animation */
@keyframes glow {
      0%, 100% { color: rgb(37, 99, 235); }  /* Dark navy */
      25% { color: #155bdd; }       /* Cyberpunk violet */
      50% { color: #346fdb; }       /* Cyberpunk neon pink */
      75% { color: #234c98; }       /* Dark blue */
    }



/* Glowing Effect Behind Letters */
.letter::before {
        content: attr(data-letter);
        position: absolute;
        left: 0;
        top: 0;
        color: transparent;
        filter: blur(3px);  /* Stronger blur for shadow effect */
        animation: glow 10s ease-in-out infinite;
        opacity: 0.2;
}
</style>
